(ns common.value-creation-status
  (:require [common.util :as cu]))

(defonce options [{:key   :value-creation.status/not-started
                   :label "Not started"}
                  {:key   :value-creation.status/work-in-progress
                   :label "Work in progress"}
                  {:key   :value-creation.status/almost-finished
                   :label "Almost finished"}
                  {:key   :value-creation.status/done
                   :label "Done"}])

(def get-key (partial cu/get-key options))

(def get-label (partial cu/get-label options))
